import { useFormikContext } from 'formik';
import { debounce } from 'lodash';
import { useEffect, useRef } from 'react';

interface OnFormChangeProps {
  onFormChange: (form: any) => void;
}

const OnFormChange = (props: OnFormChangeProps) => {
  const { onFormChange } = props;

  const formik = useFormikContext();

  // Debounce the onChangeForm to prevent infinite loops
  const onChangeFormRef = useRef<ReturnType<typeof debounce>>();

  useEffect(() => {
    if (onFormChange) {
      // The function is being debounced to prevent multiple change events
      // from being called.
      onChangeFormRef.current = debounce(onFormChange, 100);
    }
  }, [onFormChange]);

  useEffect(() => {
    if (onChangeFormRef.current) {
      onChangeFormRef.current(formik.values);
    }

    return () => {
      if (onChangeFormRef.current) {
        onChangeFormRef.current.cancel();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(formik.values), onFormChange]);

  return <></>;
};

export { OnFormChange };
